import { useState } from 'react';

const useCheckDocument = () => {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const selectItem = (item) => () =>
    selectItems([item])(!selectedIds.find((e) => e === item.id));

  const selectItems = (items: any[]) => (checked: boolean) => {
    if (checked) {
      setSelectedIds([
        ...Array.from(new Set([...selectedIds, ...items.map((i) => i.id)]))
      ]);
    } else {
      setSelectedIds(
        selectedIds.filter((e) => !items.map((i) => i.id).includes(e))
      );
    }
  };
  const groupCheckStatus = (groupitems) => {
    const noOfSelectedItems = selectedIds.filter((e) =>
      groupitems.map((i) => i.id).includes(e)
    ).length;
    return noOfSelectedItems === groupitems.length
      ? true
      : noOfSelectedItems === 0
      ? false
      : undefined;
  };
  return [
    selectedIds,
    setSelectedIds,
    selectItem,
    selectItems,
    groupCheckStatus
  ];
};

export default useCheckDocument;
